import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../../utils/propUtils';
var VeltInlineCommentsSectionSortingDropdownContentItemTickWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-inline-comments-section-sorting-dropdown-content-item-tick-wireframe", __assign({}, transformedProps), children));
};
export default VeltInlineCommentsSectionSortingDropdownContentItemTickWireframe;
